import {
    insightAreaAddMapping,
    insightAreaRemoveMapping,
} from "../../../../actions/insight-area-actions"

import buildEditMappingsContainer from "../../../common/concept-mappings/build-edit-mappings-container"
import InsightAreaConceptMappingsEditWidget from "./InsightAreaConceptMappingsEditWidget"

export default buildEditMappingsContainer(
    "insightAreas",
    null,
    null,
    insightAreaAddMapping,
    insightAreaRemoveMapping,
    InsightAreaConceptMappingsEditWidget
)
